export default __webpack_public_path__ + "static/media/icon_2.de1a2cdc.png";